module.exports = __webpack_public_path__ + "img/lathaal_divine_intervention.8da59544.png";